export class Toponym {
  public id: number;
  public name: string;
  public flg_state:string;
  public flg_kf:string;
  public flg_dpl:string;
  public user_ins_id:number;
  public ts_ins:string;
  public user_upd_id:number;
  public ts_upd:string;
}



// WEBPACK FOOTER //
// ./src/app/models/toponym.model.ts